import Model from '@/models/Model'

export default class PchPurchaseInvoice extends Model {
    resource() {
        return 'pch_purchase_invoice'
    }
}